import { TypingDots } from "@/pages/components/TypingDots/TypingDots";
import type { Editor } from "@/services/csr-chat/socket-service";

type IsTypingUIProps = {
  editor: Editor;
};

const IsTypingUI = ({ editor }: IsTypingUIProps) => (
  <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
    <p>
      {editor.name} Is <strong>Typing</strong>
    </p>
    <TypingDots />
  </div>
);

export default IsTypingUI;
